module.exports = __webpack_public_path__ + "img/3.98936f5c.jpg";